"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessfulModal = function SuccessfulModal(_ref) {
    var successfulMessage = _ref.successfulMessage;
    return _react2.default.createElement(
        "div",
        { className: "row no-margin" },
        _react2.default.createElement(
            "div",
            { className: "col-xs-12" },
            successfulMessage
        )
    );
};

exports.default = SuccessfulModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/SuccessfulModal/SuccessfulModal.js
// module id = 1793
// module chunks = 0